var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5A7.499 7.499 0 0 0 2.5 10c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5-3.357-7.5-7.5-7.5zm1.727 10.588-2.668-1.939a.365.365 0 0 1-.148-.293v-5.09c0-.2.164-.363.363-.363h1.452c.2 0 .363.164.363.363V9.93l1.92 1.398a.363.363 0 0 1 .079.508l-.853 1.173a.365.365 0 0 1-.508.079z",
    fill: "#B6E0FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockFilled);
export default __webpack_public_path__ + "static/media/icon-clock-filled.9540f531.svg";
export { ForwardRef as ReactComponent };